import React from "react";

import styles from "./Projects.module.css";
import mapImg from "./Map.jpeg";
import network from "./network.png";
import infrastructure from "./infrastructure.png";

import testemonials from "../../data/testemonial.json";
import { ProjectCard } from "./ProjectCard";
import { Carousel } from "react-bootstrap";
import { getImageUrl } from "../../utils";
import { TastemonialCard } from "./TestemonialCard";
import { projects } from "../../data/projectsData";
import { useMediaQuery, useTheme } from "@mui/material";
import Team from "../Team/Team";

export const Projects = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <section className={styles.container} id="projects">
      <div className={styles.textwithlines}>
        <div className={styles.line}></div>
        <h2 className={styles.title}>Our Products</h2>
        <div className={styles.line}></div>
      </div>
      {isMobile ? (
        <Carousel indicators={false} data-bs-theme="dark">
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
                width: "100%",
              }}
            >
              <ProjectCard key={1} project={projects.group1[0]} group={1} />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <ProjectCard key={2} project={projects.group1[1]} group={1} />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <ProjectCard key={3} project={projects.group1[2]} group={1} />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <ProjectCard key={4} project={projects.group2[0]} group={2} />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <ProjectCard key={5} project={projects.group2[1]} group={2} />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <ProjectCard key={6} project={projects.group2[2]} group={2} />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <ProjectCard key={7} project={projects.group3[0]} group={3} />
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <ProjectCard key={8} project={projects.group3[1]} group={3} />
            </div>
          </Carousel.Item>
        </Carousel>
      ) : (
        <Carousel indicators={false} data-bs-theme="dark">
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              {projects.group1.map((project, id) => {
                return <ProjectCard key={id} project={project} group={1} />;
              })}
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              {projects.group2.map((project, id) => {
                return <ProjectCard key={id} project={project} group={2} />;
              })}
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              {projects.group3.map((project, id) => {
                return <ProjectCard key={id} project={project} group={3} />;
              })}
            </div>
          </Carousel.Item>
        </Carousel>
      )}

      <div className={styles.textwithlines}>
        <div className={styles.line}></div>
        <h2 className={styles.title}>Why Choose Us</h2>
        <div className={styles.line}></div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "5rem",
          ...(isMobile && {
            flexDirection: "column",
            gap: "1rem",
          }),
        }}
      >
        <div
          style={{
            ...(isMobile && {
              display: "flex",
              justifyContent: "center",
              alignItems:"center",
              flexDirection: "column",
              width:"100%"
            }),
          }}
        >
          <div>
            <img src={network}></img>
          </div>
          <div>Our Network</div>
        </div>
        <div
          style={{
            ...(isMobile && {
              display: "flex",
              justifyContent: "center",
              alignItems:"center",
              flexDirection: "column",
              width:"100%",
              paddingLeft:"50px"
            }),
          }}
        >
          <img src={mapImg} className={styles.map}></img>
        </div>
        <div
          style={{
            ...(isMobile && {
              display: "flex",
              justifyContent: "center",
              alignItems:"center",
              flexDirection: "column",
              width:"100%"
            }),
          }}
        >
          <div>
            <img src={infrastructure}></img>
          </div>
          <div>Our Infrastructure</div>
        </div>
      </div>
    </section>
  );
};
